import { render, staticRenderFns } from "./assessment-standard.vue?vue&type=template&id=dbfa458a&scoped=true"
import script from "./assessment-standard.vue?vue&type=script&lang=js"
export * from "./assessment-standard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbfa458a",
  null
  
)

export default component.exports